import { BeheerVosStation, useUpdateVosStation } from "@/entities/medewerkers-op-station";
import { useGetStationDisplayName } from "@/entities/station";
import {
    Button,
    Dialog,
    DialogBody,
    DialogContainer,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    ErrorDisplay,
    Form,
    SwitchFormfield,
} from "@/shared/components";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const schema = z.object({
    stationsCode: z.string(),
    isVeilig: z.boolean(),
    isBemenst: z.boolean(),
});

type UpdateStationData = z.infer<typeof schema>;

type EditVosStationDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    station: BeheerVosStation;
};

export function EditVosStationDialog({ open, onOpenChange, station }: EditVosStationDialogProps) {
    const updateVosStation = useUpdateVosStation();
    const getDisplayName = useGetStationDisplayName();

    const form = useForm<UpdateStationData>({
        resolver: zodResolver(schema),
        defaultValues: {
            stationsCode: station.stationcode,
            isVeilig: station.veilig,
            isBemenst: station.bemenst,
        },
    });

    const closeAndReset = () => {
        onOpenChange(false);
        form.reset();
    };

    const onSubmit = (data: UpdateStationData) => {
        updateVosStation.mutate(
            {
                bemenst: data.isBemenst,
                veilig: data.isVeilig,
                stationcode: data.stationsCode,
            },
            {
                onSuccess: () => closeAndReset(),
            }
        );
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContainer className="w-[350px]">
                <DialogHeader>
                    <DialogTitle>Station {getDisplayName(station?.stationcode)} bewerken</DialogTitle>
                    <DialogDescription className="sr-only">Station {getDisplayName(station?.stationcode)} bewerken</DialogDescription>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={(e) => void form.handleSubmit(onSubmit)(e)}>
                        <DialogBody className="grid gap-y-4">
                            <SwitchFormfield form={form} name="isVeilig" label="Station veilig" />
                            <SwitchFormfield form={form} name="isBemenst" label="Station bemenst" />
                        </DialogBody>
                        <DialogFooter>
                            {updateVosStation.error && <ErrorDisplay error={updateVosStation.error} />}
                            <Button type="button" variant="tertiary" onClick={closeAndReset}>
                                Annuleren
                            </Button>
                            <Button disabled={updateVosStation.isPending} type="submit">
                                Opslaan
                            </Button>
                        </DialogFooter>
                    </form>
                </Form>
            </DialogContainer>
        </Dialog>
    );
}
